// ============================================
// Tabs Module
// Handles tab switching functionality for showcase pages
// ============================================

/**
 * Initialize all tab groups on the page
 * Supports multiple independent tab groups
 */
export function initTabs() {
  const tabGroups = document.querySelectorAll('.js-tabs');

  tabGroups.forEach((group) => {
    const triggers = group.querySelectorAll('.js-tab-trigger');
    const panels = group.querySelectorAll('.js-tab-panel');

    if (triggers.length === 0 || panels.length === 0) return;

    /**
     * Activate a specific tab by its data-tab value
     * @param {string} tabId - The data-tab value of the tab to activate
     */
    function activateTab(tabId) {
      // Update triggers
      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.tab === tabId;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', String(isActive));
        trigger.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      // Update panels
      panels.forEach((panel) => {
        const isActive = panel.dataset.tab === tabId;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });
    }

    // Bind click events to triggers
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const tabId = trigger.dataset.tab;
        if (tabId) {
          activateTab(tabId);
        }
      });

      // Keyboard navigation (Left/Right arrows)
      trigger.addEventListener('keydown', (e) => {
        const currentIndex = Array.from(triggers).indexOf(trigger);
        let newIndex = currentIndex;

        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          newIndex = currentIndex > 0 ? currentIndex - 1 : triggers.length - 1;
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          newIndex = currentIndex < triggers.length - 1 ? currentIndex + 1 : 0;
        }

        if (newIndex !== currentIndex) {
          const newTabId = triggers[newIndex].dataset.tab;
          if (newTabId) {
            activateTab(newTabId);
            triggers[newIndex].focus();
          }
        }
      });
    });

    // Initialize first tab as active if none are active
    const hasActiveTab = Array.from(triggers).some((t) =>
      t.classList.contains('is-active')
    );
    if (!hasActiveTab && triggers.length > 0) {
      const firstTabId = triggers[0].dataset.tab;
      if (firstTabId) {
        activateTab(firstTabId);
      }
    }
  });
}
